import React from 'react';
import PropTypes from 'prop-types';
import ImageAttachment from './ImageAttachment';
import EmbedAttachment from './EmbedAttachment';
import VideoAttachment from './VideoAttachment';
import FallbackAttachment from './FallbackAttachment';

const Attachment = ({
  attachment,
  onClick,
  ...props
}) => {
  const { type } = attachment;

  const stripUuidV4FromKey = key => {
    /**
     * the s3 key is a combination of the provided filename and uuid/v4
     * for displaying, we'll strip the uuid. below is a regex to match v4 uuids
     */
    return key.replace(/-[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}/i, '');
  };

  if (/image\/[a-zA-Z]*/.test(type)) {
    return (
      <ImageAttachment
        attachment={attachment}
        originalFilename={stripUuidV4FromKey(attachment.key)}
        expandImage={event => onClick(attachment)}
      />
    );
  } else if (/video\/[a-zA-Z]*/.test(type)) {
    return <VideoAttachment attachment={attachment} originalFilename={stripUuidV4FromKey(attachment.key)} />;
  } else if (type === 'application/pdf') {
    // this else-if will probably become more general
    return <EmbedAttachment attachment={attachment} originalFilename={stripUuidV4FromKey(attachment.key)} />;
  } else {
    return <FallbackAttachment attachment={attachment} originalFilename={stripUuidV4FromKey(attachment.key)} />;
  }
};

Attachment.propTypes = {
  attachment: PropTypes.shape({
    url: PropTypes.string,
    key: PropTypes.string,
    type: PropTypes.string
  }),
  onClick: PropTypes.func
};

export default Attachment;
